import React from 'react';
import styled from 'react-emotion';

import { BASE_COLOR } from 'shared/constants/colors';

import { mixClasses as cx } from 'helpers';


const NoteFrame = styled('div')(props => ({
  '&:before': {
    position: 'absolute',
    zIndex: 0,
    content: '""',
    background: props.color,
    top: 0,
    left: 0,
    width: '4px',
    height: '100%',
  },
}));


const Note = ({
  classes: cn,
  children,
  icon = null,
  title = null,
  color = BASE_COLOR.black,
  style = {},
}) => {
  return (
    <NoteFrame
      className={cx(
        "pa2 pl3 pr4",
        "f6 lh-title gray",
        "z-0 flex relative",
      )}
      style={style}
      color={color}
    >
      {icon &&
        <div className={cx('mr3')}>
          {icon}
        </div>
      }
      <div className={cx('moa-ff-sans flex flex-column justify-center')}>
        {title &&
          <div className={cx('mb1 f4 fw5')}>
            {title}
          </div>
        }
        <div>{children}</div>
      </div>
    </NoteFrame>
  );
};

export default Note;



// WEBPACK FOOTER //
// ./src/components/elems/Note.js